import { DropDownList } from '@progress/kendo-react-dropdowns'
import React from 'react'
import { connect } from 'react-redux'
import * as Actions from './actions'
import * as Constants from './constants'
import './styles.css'
import * as Types from './types'
import * as Utils from './utils'

interface FilterProps {
  applyFilter: Actions.FilterAction,
  filterState?: Types.Filter,
  filters?: Types.Filter[],
  disabled?: boolean,
  event: string,
  view?: Types.FilterableState
}

export const FilterSelectPure = ({applyFilter, disabled, view, filterState, event, filters}: FilterProps) =>
  <DropDownList
      disabled={disabled}
      className="active-filter"
      data={filters || Constants.StatusFilterParameters}
      textField={'description'}
      dataItemKey={'value'}
      value={Utils.statusFilterFromValue(
        (filterState || view.filter).value, (filters || Constants.StatusFilterParameters))}
      onChange={(e) => applyFilter(event, {key: (filterState || view.filter).key, value: e.target.value.value})}
  />

export const FilterSelect = connect(
  null,
  { applyFilter: Actions.applyFilter},
)(FilterSelectPure)



// WEBPACK FOOTER //
// ./src/components/is_active/filter.tsx